export default __webpack_public_path__ + "static/media/elevate-lav-banner-1.48035b78.jpg";